import React,{FunctionComponent} from 'react';
import PlaceIconRender, {PlaceIconProps} from './PlaceIconRender';


export const PlaceIcon:FunctionComponent<any> = ({valet}:PlaceIconProps):JSX.Element=>{
	return <PlaceIconRender valet={valet}/>;
};

